import { Course, Data, Match, PlayerResult, TeamGameMatch, TournamentConfig } from '../../../database.schema';
import { STABLEFORD_WITH_TEAM_GAMES } from '../../app/constants';
import { useFetchData } from '../tournament-data';

export type MatchDayResultScoreCard = {
  config: TournamentConfig;
  format: string;
  course: Course;
  startingHole: number;
  results: Array<Match>;
  resultIndex: number;
};

export const useFetchMatchDayResultScoreCard = (selectedIndex: number, dayIndex: number) => {
  return useFetchData((data: Data): MatchDayResultScoreCard => {
    switch (data?.tournaments[selectedIndex].type) {
      case STABLEFORD_WITH_TEAM_GAMES: {
        const matchData = data.tournaments[selectedIndex].teamGames?.matches ?? [];
        const courses = data.courses;
        const match = matchData[dayIndex];
        const convertedMatches: Array<Match> = [];
        match.matchPlayMatches?.forEach((teamMatchPlayMatch) => {
          const t1Players: Array<PlayerResult> = [];
          teamMatchPlayMatch.team1.playerIds.forEach((playerId) => {
            const player = matchData[dayIndex].teams[0].players.find((teamPlayer) => teamPlayer.playerId === playerId);
            if (player) {
              t1Players.push(player);
            }
          });
          const t2Players: Array<PlayerResult> = [];
          teamMatchPlayMatch.team2.playerIds.forEach((playerId) => {
            const player = matchData[dayIndex].teams[1].players.find((teamPlayer) => teamPlayer.playerId === playerId);
            if (player) {
              t2Players.push(player);
            }
          });
          const convertedMatch: Match = {
            status: '',
            date: '',
            resultMargin: teamMatchPlayMatch.resultMargin,
            resultByHole: teamMatchPlayMatch.resultByHole,
            team1: {
              points: teamMatchPlayMatch.team1.points as 0 | 0.5 | 1,
              players: [...t1Players],
            },
            team2: {
              points: teamMatchPlayMatch.team2.points as 0 | 0.5 | 1,
              players: [...t2Players],
            },
          };
          convertedMatches.push(convertedMatch);
        });

        return {
          config: data.tournaments[selectedIndex].config,
          format: 'Singles',
          results: convertedMatches,
          startingHole: matchData[dayIndex].startingHole,
          course: courses.find((course: Course) => course.id === matchData[dayIndex].courseId) ?? courses[0],
          resultIndex: dayIndex,
        };
      }
      default: {
        const matchData = data.tournaments[selectedIndex].ryderCup?.results ?? [];
        const courses = data.courses;
        return {
          config: data.tournaments[selectedIndex].config,
          format: matchData[dayIndex].format,
          results: matchData[dayIndex].matches,
          startingHole: matchData[dayIndex].startingHole,
          course: courses.find((course: Course) => course.id === matchData[dayIndex].courseId) ?? courses[0],
          resultIndex: dayIndex,
        };
      }
    }
  });
};

export type MatchDayTeamGamesResultScoreCard = {
  config: TournamentConfig;
  course: Course;
  startingHole: number;
  match: TeamGameMatch;
  resultIndex: number;
};

export const useFetchMatchDayTeamGamesResultScoreCard = (selectedIndex: number, dayIndex: number) => {
  return useFetchData((data: Data): MatchDayTeamGamesResultScoreCard => {
    const matchData = data.tournaments[selectedIndex].teamGames?.matches ?? [];
    const courses = data.courses;
    return {
      config: data.tournaments[selectedIndex].config,
      match: matchData[dayIndex],
      startingHole: matchData[dayIndex].startingHole,
      course: courses.find((course: Course) => course.id === matchData[dayIndex].courseId) ?? courses[0],
      resultIndex: dayIndex,
    };
  });
};
